import React from 'react'
import './Button.css'


const Button = (props) => {
    return(
        <div className="Button" onClick={props.clicked}>
            <button disabled={props.disabled} >{props.name}</button>
        </div>
    )
}

export default Button